import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DropdownListTextItem } from 'app/models/dropdownListTextItem';
import { I18nService } from 'app/core/services/i18n/i18n.service';
import { ValidationService } from 'app/core/services/validation/validation.service';
import { environment } from '@environments/environment';
import { ICanCancel, ITriggerOnClose } from 'app/core/services/custom-window-service/custom-window.service';
import {
  CreateFeedbackInput,
  CreateFeedbackInputKategorie,
  CreateFeedbackInputPrioritaet,
  CreateFeedbackInputTyp
} from 'app/core/services/api-client/api-client';
import { SharedFeedbackService } from '../../services/shared-feedback.service';
import { EnumHelper } from 'app/core/utils/EnumHelper';
import { ToastService } from 'app/core/services/toast-service';
import { GenericUploadErrorEvent, UploadFile, UploadFileState } from 'app/shared/components/generic-upload';
const {
  Allgemein,
  EintragInNachschlagetabelle,
} = { ...CreateFeedbackInputKategorie };

@Component({
  selector: 'app-feedback-view',
  templateUrl: './common-feedback.component.html',
})
export class CommonFeedbackComponent implements ICanCancel, ITriggerOnClose {

  public files: UploadFile[] = [];
  public uploadUrl: string = environment.baseAPIUrl + environment.feedback + 'anhang/save';

  @Input()
  public createFeedback = new CreateFeedbackInput();
  public categoryListItems = [Allgemein, EintragInNachschlagetabelle];
  public categoryItems: DropdownListTextItem[];
  public priorityListItems = EnumHelper.ToArray(CreateFeedbackInputPrioritaet);
  public priorityItems: DropdownListTextItem[];
  @Output()
  public closeWindow: EventEmitter<CreateFeedbackInput> = new EventEmitter<CreateFeedbackInput>();

  constructor(
    private sharedFeedbackService: SharedFeedbackService,
    private i18n: I18nService,
    private validationService: ValidationService,
    private readonly toastyService: ToastService,
  ) {
    this.setCategoryItems();
    this.setPriorityItems();

    this.createFeedback.beschreibung = '';
    this.createFeedback.nachschlageTabelleName = '';
    this.createFeedback.nachschlageTabelleWert = '';
    this.createFeedback.kategorie = CreateFeedbackInputKategorie.Allgemein;
    this.createFeedback.prioritaet = CreateFeedbackInputPrioritaet.Normal;
    this.createFeedback.url = window.location.href;
    this.createFeedback.typ = CreateFeedbackInputTyp.System;
  }

  public setCategoryItems(): void {
    this.categoryItems = [];
    this.categoryListItems.forEach((key: string) => {
      this.categoryItems.push({
        text: this.i18n.getLocalizedString('feedback.kategorien.' + key),
        value: key,
      });
    });
  }

  public setPriorityItems(): void {
    this.priorityItems = [];
    this.priorityListItems.forEach((key: string) => {
      this.priorityItems.push({
        text: this.i18n.getLocalizedString('feedback.prioritaeten.' + key),
        value: key,
      });
    });
  }

  public onError(event: GenericUploadErrorEvent) {
    if (event.response) {
      event.file.errorMessage = this.toastyService.getErrorMessage(event.response);
      this.toastyService.toastError(event.response);
    }
  }

  public async send() {
    try {
      this.createFeedback.anhaenge = this.files
        .filter(f => f.state === UploadFileState.Completed && f.response && f.response.anhangUid)
        .map(f => f.response.anhangUid);
      await this.sharedFeedbackService.create(this.createFeedback).toPromise();
      this.toastyService.toastSuccessFormatted(
        'feedback.messages.createSuccess.title',
        'feedback.messages.createSuccess.message',
        {},
      );
      this.closeWindow.emit(this.createFeedback);
    } catch {}
  }

  public async cancel() {
    this.closeWindow.emit(this.createFeedback);
  }

  public get canSend() {
    return (
      !this.validationService.isNullOrEmpty(this.createFeedback.kategorie) &&
      !this.validationService.isNullOrEmpty(this.createFeedback.prioritaet) &&
      !this.validationService.isNullOrEmpty(this.createFeedback.url) &&
      !this.validationService.isNullOrEmpty(this.createFeedback.beschreibung)
    );
  }
}
